import { GetterTree } from "vuex";
import { StudentTeachingState } from "./state";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<StudentTeachingState, any> = {
  //getCurrentIndependentItemId
  [defineVuexName(MODULES.STUDENT_TEACHING.GETTERS.GET_CURRENT_INDEPENDENT_ITEM_ID)](s: StudentTeachingState): null | string {
    return s.currentIndependentItemId;
  },
};

export default getters;
